import { useLocalObservable } from 'mobx-react-lite';

import { Call } from '@gem/call/CallStore/Call';
import { useCallContext } from '@gem/call/CallView/CallView.context';

export interface IMobileCompactCallViewPresenter {
  call: Call;
}

export const useMobileCompactCallViewPresenter = (): IMobileCompactCallViewPresenter => {
  const context = useCallContext();

  const presenter = useLocalObservable<IMobileCompactCallViewPresenter>(() => ({
    get call(): Call {
      return context.call;
    },
  }));

  return presenter;
};
